<i18n
  src="@/locales/views/customer/query/basic_containers/show_container.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/package_group.yml" lang="yaml"></i18n>

<template>
  <div v-if="(package_groups.length > 0)">
    <div class="flex flex-row justify-end mt-8">
      <button
        type="button"
        @click.prevent="downloadPackingListByProducerRepXlsx"
        class="btn-white"
      >
        <i
          :class="[
            'fa-solid',
            downloading0 ? 'fa-sync fa-spin' : 'fa-file-excel'
          ]"
        ></i>
        <span class="space-icon"></span>
        {{ $t("labels.download_packing_list_producer_button") }}
      </button>
      <span class="space-actions" />
      <button
        type="button"
        @click.prevent="downloadPackingListByPalletRepXlsx"
        class="btn-white"
      >
        <i
          :class="[
            'fa-solid',
            downloading1 ? 'fa-sync fa-spin' : 'fa-file-excel'
          ]"
        ></i>
        <span class="space-icon"></span>
        {{ $t("labels.download_packing_list_pallet_button") }}
      </button>
    </div>
    <div class="mt-8">
      <div class="panel">
        <dd class="">
          <div class="inline-block min-w-full">
            <div class="flex flex-wrap">
              <div
                v-for="col in cols"
                :key="col"
                :class="['divide-y divide-gray-200', card_width_class]"
              >
                <div
                  v-for="row in rows"
                  :key="row"
                  :class="[col == cols ? '' : 'border-r', 'border-gray-200']"
                >
                  <package-group-card
                    v-if="getPackageGroup(row, col)"
                    :rounded_class="cardRoundedClass(col, row)"
                    :package_group="getPackageGroup(row, col)"
                  />
                  <article
                    v-else
                    :class="[
                      'overflow-hidden text-center h-[10rem] flex place-content-center pt-5'
                    ]"
                  ></article>
                </div>
              </div>
            </div>
          </div>
        </dd>
      </div>
    </div>
  </div>
</template>

<script>
import Requester from "@/views/customer/requesters/query/basic_containers/show_container.js";
import PackageGroupCard from "@/components/views/customer/query/basic_containers/show_container/tabs/pallets/PackageGroupCard.vue";

export default {
  name: "PalletsTab",
  components: {
    PackageGroupCard
  },
  props: {
    customer_id: {
      required: true
    },
    container: {
      type: Object
    },
    package_groups: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      downloading0: false,
      downloading1: false
    };
  },
  computed: {
    action_btn_class: function () {
      return "inline-flex justify-center py-2 px-4 border shadow-sm text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2";
    },
    agro_exporter_process_id: function () {
      return this.$router.currentRoute._value.params.agro_exporter_process_id;
    },
    card_width_class: function () {
      let cols = String(this.cols ?? 1);
      let width_class = `w-1/${cols}`;
      return `${width_class} lg:${width_class}`;
    },
    container_id: function () {
      return this.$router.currentRoute._value.params.container_id;
    },
    pallet_action_btn_class: function () {
      return `${this.action_btn_class} border-indigo-700 text-indigo-700 hover:text-white hover:bg-indigo-700 focus:ring-indigo-500 w-full lg:w-1/5`;
    },
    pallet_destroy_action_btn_class: function () {
      return `${this.action_btn_class} bg-red-700 border border-red-700 text-white hover:bg-red-700 focus:ring-red-500 w-full lg:w-1/5`;
    },
    any_package_group: function () {
      if (this.package_groups) return this.package_groups.length > 0;
      return false;
    },
    cols: function () {
      return this.container?.cols_package_groups ?? 1;
    },
    rows: function () {
      return this.container?.rows_package_groups ?? 1;
    },
    max_package_groups: function () {
      return this.container?.max_package_groups ?? 0;
    },
    can_add_package_group: function () {
      return this.package_groups.length < this.max_package_groups;
    }
  },
  methods: {
    cardRoundedClass: function (col, row) {
      let def_class =
        "relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500";
      if (col == 1 && row == 1) def_class += " rounded-tl-lg";
      if (col == this.cols && row == 1) def_class += " sm:rounded-tr-lg";
      if (col == 1 && row == this.rows) def_class += " sm:rounded-bl-lg";
      if (col == this.cols && row == this.rows) def_class += " rounded-br-lg";
      return def_class;
    },
    getPackageGroup: function (row, col) {
      return this.package_groups.find(
        package_group =>
          package_group.row_position === row &&
          package_group.col_position === col
      );
    },
    downloadPackingListByProducerRepXlsx: async function () {
      if (this.downloading0) return;
      this.downloading0 = true;
      try {
        let response = await Requester.packingListByProducerRepXlsx(
          this.customer_id,
          this.container.id
        );

        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `PackingList-Productores-${this.container.container_code}.xlsx`
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
      this.downloading0 = false;
    },
    downloadPackingListByPalletRepXlsx: async function () {
      if (this.downloading1) return;
      this.downloading1 = true;
      try {
        let response = await Requester.packingListByPalletRepXlsx(
          this.customer_id,
          this.container.id
        );

        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `PackingList-Pallets-${this.container.container_code}.xlsx`
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
      this.downloading1 = false;
    }
  }
};
</script>
